import { useEffect, useState } from 'react';
import { apiGet } from '@/services/api-client';

export type PopularSearchChip = {
  query: string;
  label: string;
  count: number;
};

export async function fetchPopularSearches(): Promise<PopularSearchChip[]> {
  try {
    const res = await apiGet<{ data: PopularSearchChip[] }>('/analytics/popular-searches');
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

/** Chips “Mais buscados” do hero a partir do analytics (com fallback CMS). */
export function usePopularSearches(fallback: PopularSearchChip[]) {
  const [items, setItems] = useState<PopularSearchChip[]>(fallback);

  useEffect(() => {
    let cancelled = false;
    void fetchPopularSearches().then((rows) => {
      if (cancelled) return;
      setItems(rows.length > 0 ? rows : fallback);
    });
    return () => {
      cancelled = true;
    };
    // fallback é memoizado no Hero pelas labels/queries CMS
  }, [fallback]);

  return { items };
}
